export default "__VITE_ASSET__CaMF0wiw__"